export const services = [
  {
    icon: "ri-clipboard-line",
    title: "本質洞察",
    description: "人材の本質を科学的に見える化する、独自の検査サービスです。",
    image:
      "/images/namba/service-asystem.jpg",
  },
  {
    icon: "ri-briefcase-line",
    title: "営業支援",
    description: "営業の仕組みづくりから成果向上までを一貫して支援します。",
    image:
      "/images/namba/service-sales.jpg",
  },
  {
    icon: "ri-line-chart-line",
    title: "事業支援",
    description: "人材活用・組織づくりで事業の成長をトータルに支えます。",
    image:
      "/images/namba/service-business.jpg",
  },
];

export const painPoints = [
  {
    no: "01",
    icon: "ri-alert-line",
    text: "採用後のミスマッチを減らしたい",
    description:
      "面接だけでは見えない適性や価値観を、科学的な検査データで見える化。入社後のギャップを未然に防ぎ、定着率の向上につなげます。",
    image:
      "/images/namba/painpoint-mismatch.jpg",
  },
  {
    no: "02",
    icon: "ri-refresh-line",
    text: "離職率を改善したい",
    description:
      "離職の原因をデータで分析し、早期に兆候をキャッチ。配置や育成の見直しによって、社員が長く活躍できる環境を整えます。",
    image:
      "/images/namba/painpoint-turnover.jpg",
  },
  {
    no: "03",
    icon: "ri-layout-grid-line",
    text: "人材配置を最適化したい",
    description:
      "スキルや適性に基づいて適材適所の配置を実現。VRシミュレーションで組織編成の影響を事前に検討し、最適な人材配置を導きます。",
    image:
      "/images/namba/painpoint-placement.jpg",
  },
  {
    no: "04",
    icon: "ri-lightbulb-line",
    text: "新しい営業手法を導入したい",
    description:
      "属人的な営業ノウハウを体系化し、データに基づく営業の仕組みを構築。誰でも再現できる営業手法で、成果の安定化を支援します。",
    image:
      "/images/namba/painpoint-sales.jpg",
  },
];

export const heroTrustPoints = [
  { icon: "ri-timer-flash-line", label: "解析時間", value: "30秒" },
  { icon: "ri-bar-chart-box-line", label: "客観的データ", value: "100%" },
  { icon: "ri-earth-line", label: "国籍", value: "不問" },
];

export const features = [
  {
    no: "01",
    icon: "ri-layout-grid-line",
    title: "人材データを、ひとつの画面に可視化",
    short: "人材データの一元可視化",
    description:
      "社員のスキル・経歴・資格・評価を一元管理し、人材マップとして可視化。組織の強みや偏りをひと目で把握でき、適材適所の配置検討をスムーズにします。",
    points: [
      "スキルマップで組織の強み・偏りを可視化",
      "経歴・資格・評価をまとめて一元管理",
      "部署をまたいだ人材検索・マッチング",
    ],
    image:
      "/images/namba/feature-unified.jpg",
  },
  {
    no: "02",
    icon: "ri-focus-3-line",
    title: "VR空間で、組織の配置をシミュレーション",
    short: "VR組織シミュレーション",
    description:
      "組織図をVR空間に3Dで再現し、チーム編成の変更が組織に与える影響をシミュレーション。実際に動かす前に、最適な配置を検討できます。",
    points: [
      "VR空間でチーム編成をシミュレーション",
      "3D組織図で人材の配置・距離感を把握",
      "複数の変更案を並べて比較検討",
    ],
    image:
      "/images/namba/feature-media-link.jpg",
  },
  {
    no: "03",
    icon: "ri-scan-line",
    title: "ARで、現場のスキルをその場で見える化",
    short: "AR現場スキル可視化",
    description:
      "スマートフォンやARグラスをかざすだけで、現場のスキル状況や作業手順を重ねて表示。属人化しがちな現場のノウハウを、誰でも確認できる形にします。",
    points: [
      "現場作業をARでガイド・サポート",
      "スキル状況をその場で確認",
      "教育・OJTの効率化と標準化",
    ],
    image:
      "/images/namba/feature-scheduling.jpg",
  },
  {
    no: "04",
    icon: "ri-line-chart-line",
    title: "データ分析・レポートで、意思決定を支える",
    short: "データ分析・レポート",
    description:
      "人材データを多角的に分析し、配置・育成・採用の意思決定をデータで支援。組織の課題を可視化し、定期レポートとして自動で出力します。",
    points: [
      "組織・人材を分析するダッシュボード",
      "定例レポートをワンクリックで自動出力",
      "経営層向けのわかりやすい可視化",
    ],
    image:
      "/images/namba/feature-analytics.jpg",
  },
];

export const testimonials = [
  {
    company: "株式会社クラフティ",
    name: "人事部 課長",
    person: "田村 亮介 様",
    quote:
      "社員のスキルが人材マップで一目でわかるようになり、配置の検討がとてもラクになりました。操作もかんたんで、現場がすぐに使いこなしています。",
    image:
      "/images/namba/person-tamura.jpg",
  },
  {
    company: "株式会社オルブ",
    name: "人事総務部 マネージャー",
    person: "小泉 由美 様",
    quote:
      "VRでの配置シミュレーションは、これまで話し合いだけでは見えなかった影響を可視化してくれます。料金も明朗で、導入のハードルが低かったです。",
    image:
      "/images/namba/person-koizumi.jpg",
  },
  {
    company: "東都精密工業株式会社",
    name: "生産管理部 リーダー",
    person: "村上 健太 様",
    quote:
      "ARで現場のスキル状況をその場で確認できるのが画期的です。分析レポートのおかげで、育成計画をデータで説明できるようになりました。",
    image:
      "/images/namba/person-murakami.jpg",
  },
];

export const relatedServices = [
  {
    icon: "ri-clipboard-line",
    label: "適正検査",
    title: "適性検査システム\nA-SYSTEM",
    description:
      "性格・価値観・思考傾向を科学的に分析し、採用や配置のミスマッチを防ぐ適性検査サービスです。",
    href: "https://a-system.tech/?utm_source=namba-inc&utm_medium=referral&utm_campaign=aptitude-test&from=namba-inc",
    cta: "詳しく見る",
    image:
      "/images/namba/related-aptitude.jpg",
  },
  {
    icon: "ri-heart-pulse-line",
    label: "ストレスチェック",
    title: "ストレスチェック\nココベルケア",
    description:
      "従業員のストレス状態を手軽にチェックし、メンタル不調の早期発見と職場環境の改善を支援します。",
    href: "https://cocovel-care.jp/?utm_source=namba-inc&utm_medium=referral&utm_campaign=stress-check&from=namba-inc",
    cta: "詳しく見る",
    image:
      "/images/namba/related-stress.jpg",
  },
  {
    icon: "ri-mental-health-line",
    label: "メンタルケア",
    title: "メンタルヘルスケア支援",
    description:
      "専門家によるカウンセリングと組織的なケアで、社員が安心して働ける職場づくりをサポートします。",
    href: "https://mentalsupport.jp/?utm_source=namba-inc&utm_medium=referral&utm_campaign=mental-care&from=namba-inc",
    cta: "詳しく見る",
    image:
      "/images/namba/related-mental.jpg",
  },
  {
    icon: "ri-megaphone-line",
    label: "プロモーション",
    title: "共創型プロモーション\nPassionMovers",
    description:
      "人とマーケットを動かすプロモーション支援サービス。個人事業主でも大規模なビジネス商材を扱える共創型プラットフォームです。",
    href: "https://www.passion-movers.co.jp",
    cta: "詳しく見る",
    image:
      "https://static.wixstatic.com/media/975f36_f435b211a63a42d892da555cf9ca9102%7Emv2.png/v1/fit/w_1200,h_638,al_c/975f36_f435b211a63a42d892da555cf9ca9102%7Emv2.png",
  },
];

export const navGroups = [
  {
    title: "関連サービス",
    items: [
      {
        label: "適正検査",
        href: "https://a-system.tech/?utm_source=namba-inc&utm_medium=referral&utm_campaign=aptitude-test&from=namba-inc",
        icon: "ri-clipboard-line",
        description: "性格・価値観・思考傾向を科学的に分析し、採用や配置のミスマッチを防ぎます。",
      },
      {
        label: "ストレスチェック",
        href: "https://cocovel-care.jp/?utm_source=namba-inc&utm_medium=referral&utm_campaign=stress-check&from=namba-inc",
        icon: "ri-heart-pulse-line",
        description: "従業員のストレス状態を手軽にチェックし、メンタル不調の早期発見を支援します。",
      },
      {
        label: "メンタルヘルスケア支援",
        href: "https://mentalsupport.jp/",
        icon: "ri-mental-health-line",
        description: "専門家によるカウンセリングと組織的なケアで、安心して働ける職場づくりを支援します。",
      },
    ],
  },
  {
    title: "その他",
    items: [
      {
        label: "PassionMovers",
        href: "https://www.passion-movers.co.jp",
        icon: "ri-megaphone-line",
        description: "人とマーケットを動かす、プロモーション支援サービスです。",
      },
      {
        label: "私たちについて",
        href: "#about",
        icon: "ri-information-line",
        description: "株式会社ナンバの想いと会社概要をご紹介します。",
      },
    ],
  },
];

export const partners = [
  {
    name: "ワイルドマート合同会社",
    logo: "/images/namba/partner-wildmart.webp",
  },
  {
    name: "合同会社ココベル",
    logo: "/images/namba/partner-cocobell.webp",
  },
  {
    name: "株式会社パッションムーバーズ",
    logo: "/images/namba/partner-passionmovers.webp",
  },
  {
    name: "メンタルサポート研究所（MSi）",
    logo: "/images/namba/partner-msi.webp",
  },
];